import * as R from 'ramda'
import { createSelector } from 'reselect'

const BASE_PATH = ['errors']

const errorSelector = R.pathOr({}, BASE_PATH)

export const getErrorInterceptionSelector = createSelector(
  errorSelector,
  error => {
    return error.interception
  }
)
